import {
  ADD_POLL_ANSWER,
  ADD_POLL_ANSWER_SUCCESS,
  ADD_POLL_ANSWER_CLEAN,
  ADD_POLL_ANSWER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  pollAnswer: undefined,
}

const PollAnswerAdd = (state = initialState, action) => {
  switch (action.type) {
    case ADD_POLL_ANSWER:
      state = {
        ...state,
        loading: true,
      }
      break
    case ADD_POLL_ANSWER_SUCCESS:
      state = {
        ...state,
        pollAnswer: action.payload.pollAnswer,
        loading: false,
        done: true,
      }
      break
    case ADD_POLL_ANSWER_CLEAN:
      state = initialState
      break
    case ADD_POLL_ANSWER_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default PollAnswerAdd
